import segmentTracker from 'tracker.sgmnt';
import mixpanelTracker from 'tracker.mp';

let trackingLibrary = false;

export function setTrackingLibrary(tracker) {
  trackingLibrary = tracker === 'segment' ? segmentTracker : mixpanelTracker;
  return trackingLibrary;
}

export function getTrackingLibrary() {
  return trackingLibrary;
}



// WEBPACK FOOTER //
// ./trackingLibrary.js